import { render, staticRenderFns } from "./spoken-langs.vue?vue&type=template&id=34f1802d&scoped=true&"
import script from "./spoken-langs.vue?vue&type=script&lang=js&"
export * from "./spoken-langs.vue?vue&type=script&lang=js&"
import style0 from "./spoken-langs.vue?vue&type=style&index=0&id=34f1802d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1802d",
  null
  
)

export default component.exports